import { menuGroup, menuItem } from "modules/helpers";

// components
import PreferenceLoader from "./PreferenceLoader.doc";
import PreferenceSaver from "./PreferenceSaver.doc";

const components = [
  menuItem("<PreferenceLoader/>", "preference-loader", PreferenceLoader),
  menuItem("<PreferenceSaver/>", "preference-saver", PreferenceSaver),
];

// hooks
import UsePreferences from "./UsePreferences.doc";
import UsePreferenceValue from "./UsePreferenceValue.doc";

const hooks = [
  menuItem("usePreferences", "use-preferences", UsePreferences),
  menuItem("usePreferenceValue", "use-preference-value", UsePreferenceValue),
];

// action creators
import LoadPreferences from "./LoadPreferences.doc";
import SavePreferences from "./SavePreferences.doc";
import ResetPreferences from "./ResetPreferences.doc";
import UpdatePreference from "./UpdatePreference.doc";

const actionCreators = [
  menuItem("loadPreferences", "load-preferences", LoadPreferences),
  menuItem("savePreferences", "save-preferences", SavePreferences),
  menuItem("resetPreferences", "reset-preferences", ResetPreferences),
  menuItem("updatePreference", "update-preference", UpdatePreference),
];

// selectors
import GetPreferenceValue from "./GetPreferenceValue.doc";

const selectors = [
  menuItem("getPreferenceValue", "get-preference-value", GetPreferenceValue),
];

// configuration
import EnablePreferencesFromApi from "./EnablePreferencesFromApi.doc";
import EnablePreferencesFromDeviceStorage from "./EnablePreferencesFromDeviceStorage.doc";
import SetPreferenceDefaults from "./SetPreferenceDefaults.doc";

const configuration = [
  menuItem(
    "enablePreferencesFromApi",
    "enable-preferences-from-api",
    EnablePreferencesFromApi
  ),
  menuItem(
    "enablePreferencesFromDeviceStorage",
    "enable-preferences-from-device-storage",
    EnablePreferencesFromDeviceStorage
  ),
  menuItem(
    "setPreferenceDefaults",
    "set-preference-defaults",
    SetPreferenceDefaults
  ),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
  menuGroup("Action Creators", "action-creators", actionCreators),
  menuGroup("Selectors", "selectors", selectors),
  menuGroup("Configuration", "configuration", configuration),
];
